/**
 * created by wang lei
 前插入行页面
 *
 */
import React, {Component} from 'react';
import insertRowBeforeTool from './insertRowBefore.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class InsertRowBeforeTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            insertRowBefore:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let insertRowBefore = this.props.editor.queryCommandState('deleteTable')
        this.setState({insertRowBefore: insertRowBefore === 0});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let insertRowBefore = this.props.editor.queryCommandState('deleteTable')
        this.setState({insertRowBefore: insertRowBefore === 0});
    }

    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.insertRowBefore ? "1":"0.3"}}>
                <img className={"editor-insert-row-before-tool-btn"} src={insertRowBeforeTool} onClick={()=>this.props.editor.execCommand("insertrow")}/>
                {this.state.insertRowBefore ? <style>{`
                .editor-insert-row-before-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-insert-row-before-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-insert-row-before-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-insert-row-before-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-insert-row-before-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-insert-row-before-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}